<template>
  <div class="chikoku">
    <h3>遅刻申請</h3>
    <template v-if="form.chikoku">
      <div>
        <b class="required">月日</b>
        <div class="item">
          <date-picker v-model="form.chikoku.start_date" :error="getError(form.chikoku, 'start_date')"></date-picker>
        </div>
      </div>

      <div class="item">
        <koyouKeiyakuTimeSelect v-if="isInit" :errors="form.errors" :targetDate="form.chikoku.start_date"
          :koyouKeiyakuId="koyouKeiyakuId" :workTimeId="workTimeId" @change="changeKoyouKeiyakuTime"
          :hideWorkTime="true">
        </koyouKeiyakuTimeSelect>
      </div>

      <div class="item">
        <b class="required">出勤時刻</b>
        <time-picker v-model="form.chikoku.start_time" :startTime="{ minutes: 0 }"
          :error="getError(form.chikoku, 'start_time')"></time-picker>
      </div>

      <div class="item">
        <b class="required">事由</b>
        <input-textarea v-model="form.shinsei_jiyuu" :error="getError(form, 'shinsei_jiyuu')"></input-textarea>
      </div>
      <div class="item">
        <b>備考</b>
        <input-textarea v-model="form.notes" :error="getError(form, 'notes')"></input-textarea>
      </div>
    </template>
  </div>
</template>

<script lang="ts">

import { defineComponent, nextTick, onMounted, ref, Ref, toRefs } from 'vue';
import { useForm } from '@/composable/form/form';
import { Shinsei, ShinseiKoyouKeiyakuTime } from '@/types/Shinsei';
import KoyouKeiyakuTimeSelect from "@/components/shinsei/create/parts/KoyouKeiyakuTimeSelect.vue"
import { KoyouKeiyakuTimeSelectEmitData, SyuugyouBasyoAndKoyouKeiyakuOption } from '@/types/SyuugyouBasyo';
import { Logger } from '@/utils/Logger';

export default defineComponent({
  props: {
    form: {
      type: Object as () => Shinsei,
      default: null
    },
    targetDate: {
      type: String,
      default: null
    },
  },
  emits: {
    changeKoyouKeiyakuTime: (selectedSyuugyouBasyo: SyuugyouBasyoAndKoyouKeiyakuOption | null, selectedKoyouKeiyakuTimeOption: ShinseiKoyouKeiyakuTime | null) => true,
  },
  setup(props, context) {
    const { form } = toRefs(props)

    // 編集モードで使用する就業場所（雇用契約）と就業時間の初期値
    let workTimeId: Ref<number | null> = ref(null)
    let koyouKeiyakuId: Ref<number | null> = ref(null)

    const isInit = ref(false)

    // エラー取得
    const { getError } = useForm();

    onMounted(async () => {
      Logger.debug('----------------------------\n遅刻申請コンポーネントの初期化開始')
      Logger.debug('遅刻申請 onMounted', { '申請': form.value })
      nextTick(() => {
        Logger.debug('遅刻申請 onMounted->nextTick', { '申請': form.value })
        if (!form.value.chikoku) {
          Logger.debug('新規作成モードの初期化を行います')
          form.value.chikoku = {
            start_date: null,
            end_date: null,
            start_time: null,
            end_time: null,
            chikoku_days: null,
          }
        } else {
          Logger.debug('編集モードの初期化を行います')
          workTimeId.value = form.value.shinsei_koyou_keiyaku_time.length > 0 ? form.value.shinsei_koyou_keiyaku_time[0].koyou_keiyaku_time_id : null
          koyouKeiyakuId.value = form.value.koyou_keiyaku_id ?? null
          Logger.debug('遅刻申請より就業場所（雇用契約）と就業時間を初期化しました', { '雇用契約ID': koyouKeiyakuId.value, '就業時間ID': workTimeId.value })
        }
        isInit.value = true
        Logger.debug('遅刻申請コンポーネントの初期化完了\n----------------------------')
      })
    })

    // 就業場所・就業時間が変更された場合に走る処理
    // 引数は以下コンポーネントのemits.changeに準拠
    // src/resources/ts/components/shinsei/create/parts/KoyouKeiyakuTimeSelect.vue
    const changeKoyouKeiyakuTime = (emitData: KoyouKeiyakuTimeSelectEmitData) => {
      if (!form.value.chikoku) return

      // 就業場所に関する情報をemitする（申請オブジェクトの変更等は親に移譲する）
      context.emit('changeKoyouKeiyakuTime', emitData.selectedSyuugyouBasyo, null);
    }
    return {
      getError,
      isInit,
      changeKoyouKeiyakuTime,
      koyouKeiyakuId,
      workTimeId,
    }
  },
  components: {
    'koyouKeiyakuTimeSelect': KoyouKeiyakuTimeSelect
  }
})

</script>
<style lang="scss" scoped>
@import '@scss/components/shinsei-create.scss';
</style>
